import { Button, Flex, Input } from 'antd'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import { getUserAuthStatus } from '../../api/electronicApproval.api'
import loginApi from '../../api/login.api'
import { menuState } from '../../store/menu'
import { tokenState } from '../../store/token'
import { userAuthStatus, userState } from '../../store/user'
import '../../styles/login.scss'

function LoginPage() {
  const navigate = useNavigate()
  const [loginInfo, setLoginInfo] = useState({
    email: '',
    emailError: null,
    password: '',
    passwordError: null,
  })
  const [menu, setMenu] = useRecoilState(menuState)
  const [user, setUser] = useRecoilState(userState)
  const [token, setToken] = useRecoilState(tokenState)
  const [authStatus, setAuthStatus] = useRecoilState(userAuthStatus)

  const handleLogin = async (e) => {
    e.preventDefault()
    const param = {
      email: loginInfo.email,
      password: loginInfo.password,
    }
    const res = await loginApi.login(param)
    console.log('res::', res.data.result)
    if (res.data.code === 200) {
      setMenu(res.data.result.menuList)
      setUser(res.data.result.user)
      setToken(res.data.result.token)
      // 사용자 권한 정보 가져오기
      const authRes = await getUserAuthStatus(res.data.result.user.id)
      setAuthStatus(authRes)
      navigate('/')
    } else {
      let errorInfo = { ...loginInfo }
      if (!loginInfo.email || !loginInfo.email?.trim()) {
        errorInfo['emailError'] = true
      }
      if (!loginInfo.password || !loginInfo.password?.trim()) {
        errorInfo['passwordError'] = true
      }
      setLoginInfo(errorInfo)
      Swal.fire({
        customClass: { popup: 'custom-alert' },
        html: `<div class="login-alert-content">
<p>비밀번호가 일치하지 않습니다.</p>
<p class="login-alert-text">비밀번호를 분실하신 경우, CS팀에 문의해주세요.</p>
</div>`,
        confirmButtonText: '확인',
        confirmButtonColor: '#117FFA',
      })
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'email' && value?.trim()) {
      setLoginInfo({ ...loginInfo, [name]: value, emailError: null })
    } else if (name === 'password' && value?.trim()) {
      setLoginInfo({ ...loginInfo, [name]: value, passwordError: null })
    } else {
      setLoginInfo({ ...loginInfo, [name]: value })
    }
  }

  return (
    <Flex justify={'center'} align={'center'} flex={1} className={'login-div'}>
      <form onSubmit={handleLogin} className={'login-form-wrap'}>
        {/*제목- AOPS /  슈가코치 SALUS*/}
        <Flex gap={16}>
          <Flex justify={'center'} align={'center'} gap={12}>
            <img
              src={`${process.env.REACT_APP_HOST}/assets/aops-logo-icon.png`}
              // className={'login-logo-img'}
              style={{ width: '32px', height: '32px' }}
            />
            <p
              className={'login-title'}
              style={{ fontSize: '28px', fontWeight: '700' }}
            >
              <span>A.ops</span>
            </p>
          </Flex>
          {/* <p className={'login-title-separator'}>/</p>
          <Flex justify={'center'} align={'center'} gap={8}>
            <img
              src={`${process.env.REACT_APP_HOST}/assets/sugar-logo.png`}
              className={'login-logo-img'}
            />
            <p className={'login-title'}>
              <span>SALUS</span>
            </p>
          </Flex> */}
        </Flex>
        {/*입력창*/}
        <Flex vertical flex={1} gap={10} className={'login-input-wrap'}>
          <Flex vertical flex={1} gap={4}>
            <Input
              className={'login-input'}
              placeholder="이메일을 입력해주세요"
              name={'email'}
              value={loginInfo.email}
              onChange={handleChange}
            />
            {loginInfo.emailError && (
              <p className={'error-text'}>이메일을 입력하세요.</p>
            )}
          </Flex>
          <Flex vertical flex={1} gap={4}>
            <Input
              className={'login-input'}
              placeholder="비밀번호를 입력해주세요"
              name={'password'}
              value={loginInfo.password}
              type="password"
              onChange={handleChange}
            />
            {loginInfo.passwordError && (
              <p className={'error-text'}>비밀번호를 입력하세요.</p>
            )}
          </Flex>
        </Flex>
        {/*로그인*/}
        <Button
          htmlType={'submit'}
          type={'primary'}
          block
          className={'login-btn'}
        >
          로그인
        </Button>
      </form>
    </Flex>
  )
}

export default LoginPage
